import {useRpcSender} from "../RpcSender";
import {useState} from "react";
import {RpcState} from "../RpcState";
import {com} from "../../provider_api";
import RefundPaymentResponse = com.onkensu.platform.billing.RefundPaymentResponse;
import IRefundPaymentRequest = com.onkensu.platform.billing.IRefundPaymentRequest;
import RefundPaymentRequest = com.onkensu.platform.billing.RefundPaymentRequest;

export const UseRefundPayment = () => {

  const rpcSender = useRpcSender();
  const [rpcState, setRpcState] = useState<RpcState>({state: 'none'});
  const [response, setResponse] = useState<RefundPaymentResponse>();

  const send = (request: IRefundPaymentRequest) => {
    setRpcState({state: 'pending'});
    rpcSender.send("refund_payment", RefundPaymentRequest.encode(request).finish())
        .then(value => {
          const response = RefundPaymentResponse.decode(value);
          if (response.okay) {
            // The webhook takes a second to process the refund so this can help.
            window.location.reload()
          }
        }).catch(reason => {
      setRpcState({state: 'error', message: 'Refund failed: ' + reason})
    });
  }

  return {rpcState, response, send};
};